<template>
  <!-- <div class="page">
    <div class="header-menu">
      <navBar v-model="objSave"></navBar>
    </div>
    <div class="page-content">
     
    </div>
  </div> -->
  <div class="notify">
    <!-- <iframe id="myFrame"  height="100%" style="border-width: 0; margin: 0;padding: 0;" width="100%"
      src="/static/notify.html"></iframe> -->
    <!-- <div v-html="NotifyInfoList.NotifyContent"></div> -->
  </div>
</template>
<style scoped>
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  .header-menu header {
    background-color: #12a3ff;
  }

  .notify {
    height: 100%;
    width: 100%;
    font-size: 10px;
  }

</style>
<script>
  import navBar from '../modules/navBar.vue'
  export default {
    name: 'about',
    data() {
      return {
        objSave: {
          centerTitle: '',
        },
        NotifyInfoList: {}
      }
    },
    computed: {
      NotifyID() {
        return this.$route.query.NotifyID
      }
    },
    mounted () {
      let __self = this;
      __self.__init();

    },
    methods: {
      __init() {
        let __self = this;
        let data = {
          NotifyID: __self.NotifyID,
          NotifyTitle: '',
          NotifyType: '',
          NotifyCode: '',
          FeatureCodes: '',
          PageNo: 1,
          PageSize: 9999999,
          RecordCount: 0,
        }
        // __self.$api.admin.getNotifyInfoList(data).then(function (json) {
        //   if (json.isSucc) {
        //     __self.NotifyInfoList = json.result.entities[0];
        //     __self.objSave.centerTitle= __self.NotifyInfoList.NotifyTitle;
        //         var iframe = document.getElementById("myFrame");
        //         iframe.contentWindow.postMessage(__self.NotifyInfoList.NotifyContent);
        //   }
        // });
      }
    },
    components: {
      navBar,
    }
  }

</script>
